import React from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import PropTypes from 'prop-types'

const ContainerComponent = ({ children, className }) => {
  return <div className={className}>{children}</div>
}

ContainerComponent.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired,
  full: PropTypes.bool,
}

const widths = props =>
  props.full
    ? `width: 100%;`
    : `
    max-width: 1400px;

    @media (max-width: 1250px) { 
      width: 960px;
    }
    @media (max-width: 1023px) { 
      width: 768px;
    }
    @media (max-width: 767px) {
      width: 640px;
    }
    @media (max-width: 639px) {
      max-width: 480px;
      width: auto;
    }
 `
const Container = styled(ContainerComponent)`
  ${tw`m-auto px-4 md:px-6 lg:px-8`}
  ${widths}
`

export default Container
